module.exports = __webpack_public_path__ + "static/img/2019-10-12 14.17.50.d129033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2019-10-12 14.17.50.jpg
// module id = VJ0f
// module chunks = 4